import React from "react";
import { Box, Typography, Button, Stack, TextField } from "@mui/material";

export default function UploadCertificates({ selectedEquipment }) {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
        Upload Certificates
      </Typography>
      {selectedEquipment ? (
        <Stack spacing={2}>
          <TextField
            type="file"
            inputProps={{ accept: ".pdf,.doc,.docx,.jpg,.png" }}
            fullWidth
          />
          <Button variant="contained" color="primary">
            Upload
          </Button>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Please select an equipment to upload documents.
        </Typography>
      )}
    </Box>
  );
}
